import { connect } from "react-redux";

var CurrentUser = require("lib/account/CurrentUser");
var Activity = require("components/writing/activities/Activity");
var Board = require("components/utility/Board");

const WritingActions = require('lib/actions/WritingActions');
const WritingSelectors = require('lib/selectors/WritingSelectors');

require("writing/activities/activity_page.scss");

@connect(
	(state, props) => ({
		user: CurrentUser.get(),
		activities: WritingSelectors.getMostRecentActivities({state}) || [],
	}),
	(dispatch, props) => ({
		fetchActivities: function (attr) {
			const {filters, conditions, embeds, page, cache} = attr;
			return dispatch(WritingActions.fetchActivities({filters,conditions, embeds, page, cache}))
		},
		clearActivities: () => dispatch(WritingActions.clearActivities()),
	})
)
class StudentActivitiesPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			page: null, loading: false, doneLoading: false
		};
	}

	render() {
		var activities = this.props.activities;
		var pageBody = (
			<Board type={ Board.STUDENT_ACTIVITIES } items={ activities }
				loading={ this.state.loading } onScrollToBottom={ this.fetchActivities } />
		);

		return (
			<div className="container" id="activitiesPage">
				<header className="pageHeader">
					<h1>Activity Center</h1>
				</header>
				{ pageBody }
			</div>
		)
	}

	fetchActivities() {
		if (!this.state.doneLoading) {
			this.props
				.fetchActivities({
					page: this.state.page + 1 || null,
					embeds: ["activity.format_summary"],
					filters: {
						grade_levels: this.props.user.prefs.academic_level,

					},
				})
				.then(action => {
					const doneLoading = action.noMorePages || false;
					const page = action.pagination.page;
					
					this.setState({page, doneLoading, loading: false})
				});


			this.setState({ loading: true });
	}}

	componentDidMount() {
		this.fetchActivities();
	}
};

StudentActivitiesPage.propTypes = PageStrictPropTypes({
});

module.exports = StudentActivitiesPage;



// WEBPACK FOOTER //
// ./modules/components/writing/activities/StudentActivitiesPage.js